var _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 233,
    viewBox: "0 0 233 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.7409,
    y1: 97.5977,
    x2: 172.258,
    y2: 57.9191,
    stroke: "white",
    strokeOpacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 172.146,
    y1: 57.8159,
    x2: 141.063,
    y2: 211.477,
    stroke: "white",
    strokeOpacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.602202,
    y1: 117.176,
    x2: 155.12,
    y2: 77.4973,
    stroke: "white",
    strokeOpacity: 0.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 155.008,
    y1: 77.3941,
    x2: 123.924,
    y2: 231.055,
    stroke: "white",
    strokeOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines1);
export default __webpack_public_path__ + "static/media/lines1.ddb6635c0b51c0f438d7eabae6e5c69a.svg";
export { ForwardRef as ReactComponent };